import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type FlagProps = {
    className?: string;
};

const Flag: FunctionComponent<FlagProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'flag'}
            viewBox="0 0 250 250"
        >
            <path d="M219.6 24c-36 25.2-84.2-8.4-84.6-8.7C115.1.8 89.4 1.4 86.7 1.5 63.6.8 44.1 13.3 33.4 22V0h-9v250h9V147.8c8.9-5.7 24.5-14.7 25.8-15.4 28-14.4 51.7-7.2 63.4-1.6 4.8 2.3 13.5 7.3 15.3 8.6 16.5 11.5 31.9 15.8 32.6 15.9 8.7 2.4 16.2 3.3 22.5 3.3 24.1 0 32.6-13.5 33-14.2l.7-1.1V19l-7.1 5zm-1.9 116.6c-2.8 3.3-14.7 14.2-44.8 6-.1 0-14.6-4-29.8-14.6-2.3-1.6-11.4-6.9-16.6-9.4-13.1-6.3-39.9-14.4-71.5 1.8l-.2.1c-.6.3-12.2 7-21.4 12.7V34c6.7-6.4 28.1-24.4 53.2-23.5h.4c.2 0 24.7-1.1 42.8 12.1.5.4 13.5 9.5 31.5 15.3 21.1 6.8 40.5 6 56.5-2.2v104.9z" />
        </svg>
    );
};
export default Flag;
